import { useRouter } from 'next/router';
import Script from 'next/script';

interface Props {
	customerId: string;
}

export const MindkeyJobAgent = ({ customerId }: Props) => {
	const { locale } = useRouter();
	let mindKeyLocaleFormat = locale;

	if (locale === 'da') {
		mindKeyLocaleFormat = 'da-DK';
	}

	return (
		<>
			<Script src="https://recruiting.mindkey.com/mk-recruiting-components.js" strategy="afterInteractive" />
			<mk-job-agent customer-id={customerId} language={mindKeyLocaleFormat}></mk-job-agent>
		</>
	);
};
